




















import { Component, Prop, Vue } from "vue-property-decorator";

import Loading from "@/components/Loading.vue";

@Component({
  components: {
    Loading
  }
})
export default class Evolution extends Vue {
  @Prop({ required: true }) data!: object[];
  @Prop({ required: true }) id!: number;
  @Prop({ required: true }) name!: string;

  created() {
    // get evolution data; i.e. resolve the promise coming from that function
    this.getPokemonEvolution(this.id);
  }

  async getPokemonEvolution(speciesId: number): Promise<void> {
    let returnEvoChain;
    try {
      // let's get the species first
      const species: Response = await fetch(
        `https://pokeapi.co/api/v2/pokemon-species/${speciesId}`
      );
      const returnSpecies = await species.json();
      // then get the species' evolution chain, i.e. what other pokemon it can evolve into
      const evoChain: Response = await fetch(
        `${returnSpecies["evolution_chain"].url}`
      );
      returnEvoChain = await evoChain.json();
    } catch (err) {
      console.log(err);
    }

    if (returnEvoChain) {
      // now go through that nested data - see: https://stackoverflow.com/questions/39112862/pokeapi-angular-how-to-get-pokemons-evolution-chain
      const pokeEvolution: Array<object> = [];
      let evoData = returnEvoChain.chain;
      do {
        const numberOfEvolutions = evoData["evolves_to"].length;

        pokeEvolution.push({
          name: evoData.species.name
        });

        if (numberOfEvolutions > 1) {
          for (let i = 1; i < numberOfEvolutions; i++) {
            pokeEvolution.push({
              name: evoData["evolves_to"][i].species.name
            });
          }
        }

        evoData = evoData["evolves_to"][0];
      } while (
        !!evoData &&
        Object.prototype.hasOwnProperty.call(evoData, "evolves_to")
      );

      // assign evolution data to the shaped pokemon
      this.$emit("update:evolution", pokeEvolution);
    }
  }
}
